const Upload = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none">
      <path
        fill="#79553A"
        d="M12.617 12.745c-1.39 1.39-3.079 2.085-5.067 2.085s-3.686-.695-5.095-2.085C1.065 11.336.37 9.638.37 7.65c0-1.988.695-3.677 2.085-5.067C3.864 1.174 5.562.47 7.55.47c1.988 0 3.677.704 5.067 2.113 1.409 1.39 2.113 3.079 2.113 5.067s-.704 3.686-2.113 5.095zm-.985-9.177c-1.12-1.14-2.48-1.709-4.082-1.709-1.602 0-2.972.57-4.111 1.709-1.12 1.119-1.68 2.48-1.68 4.082 0 1.602.56 2.972 1.68 4.11 1.139 1.12 2.51 1.68 4.111 1.68 1.602 0 2.963-.56 4.082-1.68 1.14-1.138 1.708-2.508 1.708-4.11 0-1.602-.569-2.963-1.708-4.082zM8.13 11.355H6.971c-.232 0-.347-.115-.347-.347V7.65h-1.94c-.155 0-.26-.068-.319-.203-.057-.154-.038-.28.058-.376L7.32 4.176c.154-.155.308-.155.463 0l2.895 2.895c.096.096.116.222.058.376-.058.135-.164.203-.319.203h-1.94v3.358c0 .232-.115.348-.347.348z"
      />
    </svg>
  );
};

export default Upload;
